import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {API_URL} from '../../api-config';
const UserMe = () => {
  const [user, setUser] = useState({
    username: '',
    email: '',
    first_name: '',
    last_name: '',
    phone_number: ''
  });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [passwordSuccess, setPasswordSuccess] = useState('');
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const token = localStorage.getItem('token');

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const response = await axios.get(`${API_URL}/users-api/me`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setUser(response.data);
      } catch (err) {
        setError(err.response?.data?.detail || 'Failed to fetch user');
      }
    };

    fetchUser();
  }, []);

  const handleUpdateUser = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.put(
        `${API_URL}/users-api/users/me`,
        {
          username: user.username,
          email: user.email,
          first_name: user.first_name,
          last_name: user.last_name,
          phone_number: user.phone_number
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setSuccess('User updated successfully!');
      setUser(response.data);
      setError('');
    } catch (err) {
      const errorMessage = err.response?.data?.detail || 'Failed to update user';
      if (typeof errorMessage === 'object') {
        setError(JSON.stringify(errorMessage));
      } else {
        setError(errorMessage);
      }
    }
  };

  const handleChangePassword = async (e) => {
    e.preventDefault();
    try {
      await axios.put(
        `${API_URL}/users-api/users/change-password`,
        {
          current_password: currentPassword,
          new_password: newPassword
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
            'accept': 'application/json'
          },
        }
      );
      setCurrentPassword('');
      setNewPassword('');
      setPasswordSuccess('Password updated successfully!');
    } catch (err) {
      console.log('Error completo:', err.response);
      setError(err.response?.data?.detail || 'Failed to change password');
    }
  };
  

  return (
    <div className="flex flex-col md:flex-row justify-around bg-[#101523] w-full p-12 text">
      {/* Información del Usuario */}
      <div className="w-full md:w-1/2 max-w-lg p-8 space-y-6 bg-[#101523] rounded-lg shadow-md border mb-6 md:mb-0 md:mr-6">
        <h2 className="text-2xl font-bold text-center">User Information</h2>
        {error && (
          <div className="p-2 mb-4 text-sm text-red-700 bg-red-200 rounded">
            {typeof error === 'object' ? JSON.stringify(error) : error}
          </div>
        )}
        {success && <div className="p-2 mb-4 text-sm text-green-700 bg-green-200 rounded">{success}</div>}
        {user && (
          <div>
            <div>
              <label className="block text-sm font-medium">Username</label>
              <input
                type="text"
                value={user.username}
                onChange={(e) => setUser({ ...user, username: e.target.value })}
                className="w-full px-3 py-2 mt-1 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-black"
              />
            </div>
            <div>
              <label className="block text-sm font-medium mt-4">Email</label>
              <input
                type="email"
                value={user.email}
                readOnly
                className="w-full px-3 py-2 mt-1 border border-gray-300 rounded-lg bg-gray-200 cursor-not-allowed focus:outline-none focus:ring-2 focus:ring-blue-500 text-black"
              />
            </div>
            <div>
              <label className="block text-sm font-medium mt-4">First Name</label>
              <input
                type="text"
                value={user.first_name || ''}
                onChange={(e) => setUser({ ...user, first_name: e.target.value })}
                className="w-full px-3 py-2 mt-1 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-black"
              />
            </div>
            <div>
              <label className="block text-sm font-medium mt-4">Last Name</label>
              <input
                type="text"
                value={user.last_name || ''}
                onChange={(e) => setUser({ ...user, last_name: e.target.value })}
                className="w-full px-3 py-2 mt-1 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-black"
              />
            </div>
            <div>
              <label className="block text-sm font-medium mt-4">Phone Number</label>
              <input
                type="text"
                value={user.phone_number || ''}
                onChange={(e) => setUser({ ...user, phone_number: e.target.value })}
                className="w-full px-3 py-2 mt-1 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-black"
              />
            </div>
            <button
              onClick={(e) => handleUpdateUser(e)}
              className="w-full px-4 py-2 mt-6 text-white bg-blue-500 rounded-lg hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              Update User
            </button>
          </div>
        )}
      </div>

      {/* Cambio de contraseña */}
      <div className="w-full md:w-1/2 max-w-lg p-8 space-y-6 bg-[#101523] rounded-lg shadow-md border ml-4">
        <h2 className="text-2xl font-bold text-center">Change Password</h2>
        {passwordSuccess && <div className="p-2 mb-4 text-sm text-green-700 bg-green-200 rounded">{passwordSuccess}</div>}
        
        {/* Campo para la contraseña actual */}
        <div>
          <label className="block text-sm font-medium">Current Password</label>
          <div className="relative">
            <input
              type={showCurrentPassword ? "text" : "password"}
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              className="w-full px-3 py-2 mt-1 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-black"
            />
            <button
              type="button"
              onClick={() => setShowCurrentPassword(!showCurrentPassword)}
              className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700 focus:outline-none"
            >
              <svg viewBox="0 0 576 512" height="1.10em" xmlns="http://www.w3.org/2000/svg" fill="currentColor">
                <path d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-64c0 35.3-28.7 64-64 64c-7.1 0-13.9-1.2-20.3-3.3c-5.5-1.8-11.9 1.6-11.7 7.4c.3 6.9 1.3 13.8 3.2 20.7c13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3z"></path>
              </svg>
            </button>
          </div>
        </div>

        {/* Campo para la nueva contraseña */}
        <div>
          <label className="block text-sm font-medium">New Password</label>
          <div className="relative">
            <input
              type={showNewPassword ? "text" : "password"}
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              className="w-full px-3 py-2 mt-1 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-black"
            />
            <button
              type="button"
              onClick={() => setShowNewPassword(!showNewPassword)}
              className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700 focus:outline-none"
            >
              <svg viewBox="0 0 576 512" height="1.10em" xmlns="http://www.w3.org/2000/svg" fill="currentColor">
                <path d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-64c0 35.3-28.7 64-64 64c-7.1 0-13.9-1.2-20.3-3.3c-5.5-1.8-11.9 1.6-11.7 7.4c.3 6.9 1.3 13.8 3.2 20.7c13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3z"></path>
              </svg>
            </button>
          </div>
        </div>

        <button
          onClick={handleChangePassword}
          className="w-full px-4 py-2 mt-4 text-white bg-purple-500 rounded-lg hover:bg-purple-600 focus:outline-none focus:ring-2 focus:ring-purple-500"
        >
          Change Password
        </button>
      </div>
    </div>
  );
};

export default UserMe;
